import {
  Package,
  Truck,
  MapPin,
  Store,
  Tag,
  TriangleAlert,
  QrCode,
  BarChart3,
  TrendingUp,
  FileText,
  ShoppingBag,
  ShoppingCart,
  ClipboardList,
  ClipboardCheck,
  ClipboardPen,
  Monitor,
  Building2,
  RotateCcw,
  type LucideIcon,
} from 'lucide-react';

export interface PagePermissionEntry {
  key: string;
  label: string;
  description: string;
  icon: LucideIcon;
  route: string;
}

export const PAGE_REGISTRY: PagePermissionEntry[] = [
  { key: 'inventory',        label: 'Inventory',            description: 'View and manage product inventory',          icon: Package,        route: '/inventory' },
  { key: 'incoming',         label: 'Incoming Shipments',   description: 'Manage incoming shipments',                  icon: Truck,          route: '/incoming' },
  { key: 'outgoing',         label: 'Outgoing Shipments',   description: 'Manage outgoing shipments',                  icon: Truck,          route: '/outgoing' },
  { key: 'package-tracing',  label: 'Package Tracing',      description: 'Track and trace packages',                   icon: MapPin,         route: '/package-tracing' },
  { key: 'in-house-shipment', label: 'In-house Shipment',   description: 'Internal transfers and reservations',        icon: Store,          route: '/in-house-shipment' },
  { key: 'return-shipment',  label: 'Return Shipment',      description: 'Process customer returns back to warehouse', icon: RotateCcw,      route: '/return-shipment' },
  { key: 'shipping-labels',  label: 'Shipping Labels',      description: 'Create and manage shipping labels',          icon: Tag,            route: '/shipping-labels' },
  { key: 'orders-issues',    label: 'Orders Issue',         description: 'Track and resolve order issues',             icon: TriangleAlert,  route: '/orders-issues' },
  { key: 'barcode-generator', label: 'Barcode Generator',   description: 'Generate barcodes for products',             icon: QrCode,         route: '/barcode-generator' },
  { key: 'reports',          label: 'Reports',              description: 'View and export reports',                    icon: BarChart3,      route: '/reports' },
  { key: 'analytics',        label: 'Analytics Dashboard',  description: 'View analytics and insights',                icon: TrendingUp,     route: '/analytics' },
  { key: 'sales-invoices',   label: 'Sales Invoices',       description: 'Manage sales invoices',                      icon: FileText,       route: '/sales-invoices' },
  { key: 'sales-history',    label: 'Sales History',        description: 'View sales history records',                 icon: TrendingUp,     route: '/sales-history' },
  { key: 'shopify',          label: 'Shopify Integration',  description: 'Manage Shopify store connections',           icon: ShoppingBag,    route: '/shopify' },
  { key: 'shopify-orders',   label: 'Shopify Orders',       description: 'View and fulfil Shopify orders',             icon: ShoppingCart,    route: '/shopify/orders' },
  { key: 'worker-terminal',  label: 'Worker Terminal',      description: 'Order picking and fulfilment terminal',      icon: ClipboardList,  route: '/worker-terminal' },
  { key: 'reservation-terminal', label: 'Reservation Terminal', description: 'Reservation picking and fulfilment terminal', icon: ClipboardCheck, route: '/reservation-terminal' },
  { key: 'shop-terminal',    label: 'Shop Terminal',        description: 'Shop confirmation of warehouse deliveries',   icon: Store,          route: '/shop-terminal' },
  { key: 'shop-stock-count', label: 'Shop Stock Count',     description: 'Count shop stock by scanner or one-by-one',  icon: ClipboardPen,   route: '/shop-stock-count' },
  { key: 'devices',          label: 'Device Manager',       description: 'Manage connected devices',                   icon: Monitor,        route: '/devices' },
  { key: 'b2b',              label: 'B2B Portal',           description: 'B2B buyer portal and reservations',          icon: Building2,      route: '/b2b' },
];

export const ALL_PAGE_KEYS = PAGE_REGISTRY.map((p) => p.key);

export type PageKey = (typeof PAGE_REGISTRY)[number]['key'];

export function isPageControllable(pageKey: string): boolean {
  return ALL_PAGE_KEYS.includes(pageKey);
}

export function getPageConfig(pageKey: string): PagePermissionEntry | undefined {
  return PAGE_REGISTRY.find((p) => p.key === pageKey);
}

/** Map route paths to their page key for quick lookup */
const ROUTE_TO_KEY: Record<string, string> = {};
for (const p of PAGE_REGISTRY) {
  ROUTE_TO_KEY[p.route] = p.key;
}

export function getPageKeyByRoute(route: string): string | undefined {
  return ROUTE_TO_KEY[route];
}
